import React from 'react';
import { Box } from '@mui/material';
import { surfaceFor } from './statusMaps';

/** Rounded accent square holding an icon — used by KG metric tiles, section heads. */
export default function IconTile({ icon, accent = 'brand', size = 44, sx = {} }) {
  const surf = surfaceFor(accent);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: `${Math.round(size * 0.32)}px`,
        bgcolor: surf.bg,
        color: surf.fg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& svg': { fontSize: Math.round(size * 0.5) },
        ...sx,
      }}
    >
      {icon}
    </Box>
  );
}
